'use strict';

import template from '../../templates/timesheet/Row.ejs';
import loader from 'helpers/loader.js';
import PayrollItem from 'newModels/payroll-item.js';
import moment from 'moment';
import Alerts from 'lib/alerts';

module.exports = Backbone.View.extend({
    tagName: 'tbody',

    events() {
        return {
            'change .js-hours': 'updateHours',
            'focus .js-hours': 'selectAllText',
            'click .js-destroy': 'destroy'
        };
    },

    initialize(options) {
        this.options = _.defaults(options || {}, {
            date: moment().startOf('week').toDate()
        });
        return this;
    },

    render() {
        const date = moment(this.options.date);
        const weekStart = date.clone().startOf('week');
        const weekEnd = date.clone().endOf('week');
        let dates = [];
        while (!weekStart.isAfter(weekEnd)) {
            dates.push(weekStart.clone());
            weekStart.add(1, 'day');
        }
        this.$el.html(template({
            model: this.model,
            dates: dates
        }));
        this.renderTotals();
        return this;
    },

    selectAllText(ev) {
        this.$(ev.currentTarget).select();
    },

    updateHours(ev) {
        const $input = this.$(ev.currentTarget);
        const hours = _.isNaN(parseFloat($input.val() || 0)) ?
            0 : parseFloat($input.val() || 0);
        const date = moment($input.data('entryDate'), 'DDMMYYYY');
        const item = $input.data('entryItem') ?
            new PayrollItem({id: $input.data('entryItem')}) : null;
        const timeEntry = this.model.getTimeEntry(date.toDate(), item);

        if (!timeEntry) {
            return;
        }

        timeEntry.set({hours: hours});
        $input.val(hours);
        this.renderTotals(date);
        return this;
    },

    renderTotals(date = null) {
        const $weeklyTotal = this.$('.js-weekly-row-total');
        const $monthlyTotal = this.$('.js-monthly-row-total');
        const $globalWeekly = this.$('.js-totals .js-weekly-total');
        const $globalMonthly = this.$('.js-totals .js-monthly-total');

        let globalWeeklyTotal = 0;
        let globalMonthlyTotal = 0;

        $weeklyTotal.each((i, el) => {
            const $el = this.$(el);
            const item = $el.data('entryItem') ?
                new PayrollItem({id: $el.data('entryItem')}) : null;
            const total = this.model.getTimeEntriesWeeklyTotal(
                this.options.date,
                item
            );
            $el.val(parseFloat((total || 0).toFixed(2)));
            globalWeeklyTotal += (total || 0);
        });

        $monthlyTotal.each((i, el) => {
            const $el = this.$(el);
            const item = $el.data('entryItem') ?
                new PayrollItem({id: $el.data('entryItem')}) : null;
            const total = this.model.getTimeEntriesMonthlyTotal(
                this.options.date,
                item
            );
            $el.val(parseFloat((total || 0).toFixed(2)));
            globalMonthlyTotal += (total || 0);
        });

        $globalWeekly.val(parseFloat((globalWeeklyTotal || 0).toFixed(2)));
        $globalMonthly.val(parseFloat((globalMonthlyTotal || 0).toFixed(2)));

        if (date) {
            const $dailyTotal = this.$(
                `.js-daily-total[data-entry-date=${date.format('DDMMYYYY')}]`
            );
            $dailyTotal.val(parseFloat(
                (this.model.getTimeEntriesDailyTotal(date.toDate()) || 0)
                    .toFixed(2)
            ));
        }
    },

    destroyConfirm() {
        const resolver = Promise.defer();

        Alerts.show('infoConfirm', {
            showCloseButton: true,
            allowEscapeKey: true,
            width: 700,
            title: 'Delete all entries in current month?',
            text: (
                `If you agree we'll delete all monthly entries related to ` +
                `this item. Otherwise, we'll only delete the entries for ` +
                `the current week.\n\n` +
                `Note that you can cancel this operation by clicking ` +
                `outside this modal dialog, or pressing the "Esc" key.`
            ),
            confirmButtonText: `Yes, Delete All Month Entries`,
            cancelButtonText: `No, Only Delete Week Entries`,
            callback: confirm => {
                if (confirm) {
                    resolver.resolve(false);
                } else {
                    resolver.resolve(true);
                }
            }
        });

        return resolver.promise;
    },

    destroy(ev) {
        const $el = this.$(ev.currentTarget);
        const itemId = $el.data('entryItemId');
        const item = itemId ? new PayrollItem({id: itemId}) : null;
        let stopLoader = () => {};

        return this.destroyConfirm().then(weekOnly => {
            stopLoader = loader.startFullScreen();
            return this.model.deleteTimeEntries(
                this.options.date,
                item,
                weekOnly ? 'week' : 'month'
            );
        }).then(() => {
            this.trigger('re-render');
        }, () => stopLoader());
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/timesheet/Row.js